import { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import publicAPI from '../../publicApi';
import AppPrompt from '../../components/AppPrompt';
import './PublicPage.css';

/**
 * 공개 수업일정 페이지
 * URL: /:tenantId/schedule/:id?token=xxx
 */
export default function PublicSchedule() {
  const { tenantId, id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [schedule, setSchedule] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadSchedule = useCallback(async () => {
    if (!token) {
      setError('유효하지 않은 링크입니다');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const { data } = await publicAPI.getSchedule(tenantId, id, token);
      setSchedule(data);
      setError(null);
    } catch (err) {
      console.error('Failed to load schedule:', err);
      setError(err.response?.data?.error || '수업일정을 불러오는데 실패했습니다');
    } finally {
      setLoading(false);
    }
  }, [tenantId, id, token]);

  useEffect(() => {
    loadSchedule();
  }, [loadSchedule]);

  if (loading) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="loading-spinner">로딩 중...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="error-message">
            <h3>⚠️ 오류</h3>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!schedule) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="error-message">
            <h3>📅 수업일정을 찾을 수 없습니다</h3>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="public-page">
      <AppPrompt />
      <div className="public-container">
        <div className="public-header">
          <div className="header-badge">수업일정</div>
          <h1 className="public-title">{schedule.title}</h1>
          <div className="public-meta">
            <span className="meta-item">📅 {schedule.date}</span>
          </div>
        </div>

        <div className="public-section">
          <div className="section-content">
            {schedule.content || schedule.description}
          </div>
        </div>

        <div className="public-footer">
          <p className="footer-text">EduStaff 학원관리 시스템</p>
        </div>
      </div>
    </div>
  );
}
